import React, { useEffect, useState } from 'react';
import Main from '../../Main';
import { Col, Dropdown, Row } from 'react-bootstrap';
import columnFilter from '../../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../../assets/images/CustomerManagement/valueFilter.svg'
import '../../../assets/css/dashboard.scss'
import '../../../assets/css/customermanagement.scss'
import 'react-datepicker/dist/react-datepicker.css';
import SbCancelBtn, { SbAddBtn, SbFilterBtn } from '../../Buttons/Buttons';
import Select from 'react-select';
import Download from '../../MainSection/Download/Download';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loadAssignedModulesDropdownData, loadCompanyDropdownData, loadDesignationData, loadSettingsDashboardCategory, loadSettingsDynamicDashboard, loadSettingsDynamicDashboardCategoryDropdown, loadSettingsSingleDashboardCategoryData, loadSettingsSingleDynamicDashboardData, loadSingleDesignationData, postDashboardCategoryDatas, postDesignationDatas, postDynamicDashboardDatas } from '../../../redux/action';
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { ADDED_BY_ID } from '../../../Constants';
import DashboardCategoryTable from './DashboardCategoryTable';
import AddDashboardCategory from './AddDashboardCategory';
import DashboardCategoryColumnFilter from './DashboardCategoryColumnFilter';
import SbDropdownButton from '../../Buttons/SbDropdownButton';
import DashboardCategoryBulkUploadModal from './DashboardCategoryBulkUploadModal';

const enablingOptions = [
    { value: 115, label: "Active" },
    { value: 116, label: "Inactive" }
]

const DashboardCategory = () => {

    let dispatch = useDispatch();
    const { id: userRefId } = useParams();

    const { dashboardCategoryData, totalDataCount, getDynamicDashboardCategoryDropdownData, getCompanyDropdown, singleDashboardCategoryData, assignedModulesDropdown } = useSelector((state) => state.data);
    // console.log(singleDashboardCategoryData, 'singleDashboardCategoryData')
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showCustomerViewDetails, setShowCustomerViewDetails] = useState(false);
    const [businessUnitModal, setBusinessUnitModal] = useState(false);
    const [branchPlantModal, setBranchPlantModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [selectedColumns, setSelectedColumns] = useState([
        "DASHBOARD CATEGORY ID", "DASHBOARD CATEGORY NAME", "STATUS", "ACTION"
    ]);
    const [dashboardCategoryId, setDashboardCategoryId] = useState("");
    const [selectedStatusID, setSelectedStatusID] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
    const [dataLoading, setDataLoading] = useState(false);

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };
    const handleOpenModal = (dashboardLibId) => {
        setIsModalOpen(true);
        if (dashboardLibId) {
            dispatch(loadSettingsSingleDashboardCategoryData(setDataLoading, dashboardLibId))
            setDashboardCategoryId(dashboardLibId);
        } else {
            setDashboardCategoryId("");
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleOpenBulkUploadModal = () => {
        setShowBulkUploadModal(true);
    };
    const handleCloseBulkUploadModal = () => {
        setShowBulkUploadModal(false);
    };

    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    const handleViewDetails = () => {
        setShowCustomerViewDetails(!showCustomerViewDetails);
    }

    useEffect(() => {
        if (userRefId) {
            dispatch(loadSettingsSingleDashboardCategoryData(setDataLoading, userRefId));
        } else {
            fetchDashboardCategory();
        }
    }, [userRefId]);

    const fetchDashboardCategory = (statusID = null, clientID = null) => {
        dispatch(loadSettingsDashboardCategory(setLoading, rowsPerPage, page + 1, statusID, clientID));
    }

    // useEffect(() => {
    //     fetchDashboardCategory();
    // }, [page, rowsPerPage]);

    useEffect(() => {
        fetchDashboardCategory(selectedStatusID, selectedCategory);
    }, [page, rowsPerPage, selectedStatusID, selectedCategory]);

    useEffect(() => {
        dispatch(loadSettingsDynamicDashboardCategoryDropdown());
        dispatch(loadCompanyDropdownData());
        dispatch(loadAssignedModulesDropdownData());
    }, [])

    const handleColumnSelectionChange = (updatedSelectedColumns) => {
        setSelectedColumns(updatedSelectedColumns); // Update the selected columns
    };

    const handleClientSelection = (selectedOption) => {
        const DashboardCategoryID = selectedOption ? selectedOption.value : null;
        setSelectedCategory(DashboardCategoryID);
        fetchDashboardCategory(selectedCategory, DashboardCategoryID); // Pass both status and client ID
    };

    const handleStatusSelection = (selectedOption) => {
        if (selectedOption) {
            const statusID = selectedOption.value;  // Extract StatusID (assuming 'value' is the StatusID)
            setSelectedStatusID(statusID);  // Store StatusID in state
            fetchDashboardCategory(statusID);  // Call API with both StatusID and current RoleID
        }
    };

    const handleCategorySelection = (selectedOption) => {
        const clientID = selectedOption ? selectedOption.value : null;
        setSelectedCategory(clientID);
        fetchDashboardCategory(selectedStatusID, clientID); // Pass both status and client ID
    };

    const handleStatusChange = (customer, statusLabel) => {
        const statusID = statusLabel === "Active" ? 115 : 116; // 12 for Active, 13 for Inactive

        console.log(customer, 'customer')
        const data = {
            CompanyID: customer.CompanyID || null,
            DashboardCategoryName: customer.DashboardCategoryName || null,
            AddedByID: ADDED_BY_ID,
            StatusID: statusID || null,
        }
        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };

        // Dispatch the action to update the department status
        dispatch(postDashboardCategoryDatas(requestOption, handleCloseModal, fetchDashboardCategory, customer.DashboardCategoryID));
        console.log(data, 'data'); // For debugging purposes
    };

    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1);
    };

    const handleClearFilters = () => {
        setSelectedStatusID(null);
        setSelectedCategory(null);
        fetchDashboardCategory();
    }

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        moduleName="Settings / Dashboard Category"
                        onBackClick={handleBack}
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={3} className='customermanagement-backbtn-div'>
                                {/* <img src={backbtn} alt="" /> */}
                                <span>Dashboard Category</span>
                            </Col>
                            <Col md={9} className='customermanagement-search-filter'>
                                <div className='customermanagement-header-btns filter-btn'>
                                    {/* <SbFilterBtn btnName="Filters" onClickEffect={toggleFilterMenu} /> */}
                                    {showFilterMenu && (
                                        <Dropdown.Menu show className='filter-dropdown-options'>
                                            <Dropdown.Item onClick={handleOpenColumnFilterModal}>
                                                <img src={columnFilter} alt="" />&nbsp;&nbsp;
                                                Column Filter
                                            </Dropdown.Item>
                                            {/* <Dropdown.Item onClick={handleOpenValueFilterModal}>
                                                <img src={valueFilter} alt="" />&nbsp;&nbsp;
                                                Value Filter
                                            </Dropdown.Item> */}
                                        </Dropdown.Menu>
                                    )}
                                </div>
                                <Col md={3}>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        options={getDynamicDashboardCategoryDropdownData}
                                        style={{ width: "100%" }}
                                        placeholder="Select Category"
                                        name="DashboardCategoryID"
                                        value={selectedCategory ? getDynamicDashboardCategoryDropdownData.find(option => option.value === selectedCategory) : null}
                                        onChange={(selectedOption) => handleCategorySelection(selectedOption)}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="Search Status"
                                        options={enablingOptions}
                                        style={{ width: "100%" }}
                                        value={selectedStatusID ? enablingOptions.find(status => status.value === selectedStatusID) : null}
                                        onChange={(selectedOption) => handleStatusSelection(selectedOption)}
                                    />
                                </Col>
                                <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                                {/* <SbAddBtn btnName="Add" onClickEffect={() => { handleOpenModal("") }} /> */}
                                <SbDropdownButton
                                    btnName="Add"
                                    openAddModal={() => { handleOpenModal("") }}
                                    addBulkModel={handleOpenBulkUploadModal}
                                />
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            <DashboardCategoryTable
                                handleOpenModal={handleOpenModal}
                                handleViewDetails={handleViewDetails}
                                dashboardCategoryData={dashboardCategoryData}
                                loading={loading}
                                page={page}
                                setPage={setPage}
                                rowsPerPage={rowsPerPage}
                                setRowsPerPage={setRowsPerPage}
                                totalDataCount={totalDataCount}
                                selectedColumns={selectedColumns}
                                handleStatusChange={handleStatusChange}
                                singleDashboardCategoryData={singleDashboardCategoryData}
                                userRefId={userRefId}
                            />
                        </div>
                    </div>
                </div>
            </Main>
            {
                isModalOpen && <AddDashboardCategory
                    open={isModalOpen}
                    handleCloseModal={handleCloseModal}
                    getDynamicDashboardCategoryDropdownData={getDynamicDashboardCategoryDropdownData}
                    getCompanyDropdown={getCompanyDropdown}
                    fetchDashboardCategory={fetchDashboardCategory}
                    dashboardCategoryId={dashboardCategoryId}
                    singleDashboardCategoryData={singleDashboardCategoryData}
                    enablingOptions={enablingOptions}
                    assignedModulesDropdown={assignedModulesDropdown}
                    dataLoading={dataLoading}
                />
            }
            {
                showBulkUploadModal && <DashboardCategoryBulkUploadModal
                    showBulkUploadModal={showBulkUploadModal}
                    handleCloseBulkUploadModal={handleCloseBulkUploadModal}
                    fetchDashboardCategory={fetchDashboardCategory}
                />
            }
            {showColumnFilterModal && (
                <DashboardCategoryColumnFilter
                    showColumnFilterModal={showColumnFilterModal}
                    handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                    selectedColumns={selectedColumns}
                    handleSaveColumns={handleColumnSelectionChange}
                />
            )}
            {/* {showValueFilterModal && (
                <CustomerValueFilterModal
                    showValueFilterModal={showValueFilterModal}
                    handleCloseValueFilterModal={handleCloseValueFilterModal}
                />
            )}
            {showCustomerViewDetails && (
                <CustomerViewDetails
                    showCustomerViewDetails={showCustomerViewDetails}
                    handleCloseViewDetails={handleCloseViewDetails}
                />
            )} */}
        </div >
    );
};

export default DashboardCategory;